import React from 'react';
import { ReactionAfterwards } from '../../../../Game/Level/Blok/ActieReactie';

import RadioButton from '../../Default/RadioButton';

export default function AfterReaction({ afterwards, updateBlokStateActionReaction }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row">
                <RadioButton
                    name="afterwards"
                    value={ReactionAfterwards.StayTheSame}
                    activeValue={afterwards}
                    onChange={e =>
                        updateBlokStateActionReaction({
                            afterwards: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Ik blijf normaal en reageer de volgende keer weer
                </RadioButton>
                <RadioButton
                    name="afterwards"
                    value={ReactionAfterwards.Disappear}
                    activeValue={afterwards}
                    onChange={e =>
                        updateBlokStateActionReaction({
                            afterwards: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Ik verdwijn
                </RadioButton>
                <RadioButton
                    name="afterwards"
                    value={ReactionAfterwards.ChangeState}
                    activeValue={afterwards}
                    onChange={e =>
                        updateBlokStateActionReaction({
                            afterwards: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Ik word anders...
                </RadioButton>
            </div>
        </div>
    );
}
